<template>
    <div class="delete">
        <div class="inner">
            <h2>Tem a certeza que pretende {{ options }} {{ name }}</h2>
            <div class="answers">
                <button class="execute" @click="execute">Confirmar</button>
                <button class="cancel" @click="cancel">Cancelar</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name:"PopupComponent",
    props: {
        name: { default: null },
        options: { default: null }
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        execute() {
            this.$emit("execute");
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/utilities/_variables.scss';

.delete {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(var(--black), .2);
    z-index: 8000;

    .inner {
        background-color: var(--card-bg);
        border: 1px solid var(--text-color);
        padding: 40px;
        width: auto;
        border-radius: 20px;

        .answers {
            display: flex;
            justify-content: space-around;
            align-items: center;
            
            .execute {
                background-color: var(--highlight-color);
                color: var(--highlight-bg-text-color);
                border: none;
                padding: 10px 10px;
                font-size: 16px;
                border-radius: 10px;
                cursor: pointer;
            }
            
            .cancel {
                background-color: var(--bg-color-2);
                color: var(--text-color);
                border: none;
                font-size: 16px;
                padding: 10px 10px;
                border-radius: 10px;
                cursor: pointer;
            }
        }
    }
}
</style>
